import { useIsMobile } from '../../../../hooks/use-mobile';
import { router } from "@inertiajs/react";
import { Search } from "lucide-react"
import { Input, Button } from '../../../../components/ui';
import styles from './styles.module.css';
import { useRef, useState } from 'react';
import { trackEvent } from '../../../../utils/analytics';

const popularSearch = [
  // {
  //   tag: "Citadine",
  //   params: {
  //     carrosserie: ["Citadine"]
  //   }
  // },
  // {
  //   tag: "Vans",
  //   params: {
  //     carrosserie: ["Vans"]
  //   }
  // },
  // {
  //   tag: "Break",
  //   params: {
  //     carrosserie: ["Break"]
  //   }
  // },
  // {
  //   tag: "Electrique",
  //   params: {
  //     type_moteur: ["moteur électrique"]
  //   }
  // },
  // {
  //   tag: "Diesel",
  //   params: {
  //     type_moteur: ["Diesel"]
  //   }
  // },
  {
    tag: "Renault",
    params: {
      brand: "Renault"
    }
  },
  {
    tag: "Peugeot",
    params: {
      brand: "Peugeot"
    }
  },
  {
    tag: "Volkswagen",
    params: {
      brand: "Volkswagen"
    }
  }
]

const HomeSearchBlock = () => {
  const isMobile = useIsMobile();
  const inputRef = useRef<HTMLInputElement>(null);

  const onPopularClear = (popular) => {
    router.get(`/vehicles`, {
      search: popular.params
    })
  }

  const trackSearchButtonClick = () => {
    trackEvent({
      name: "Rechercher un véhicule par mot-clé",
      params: {
        category: "Interaction",
        action: "Click",
        label: "Rechercher un véhicule par mot-clé",
        page_type: "page d'accueil",
      }
    })
  }

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      trackSearchButtonClick();
      router.get(`/vehicles`, {
        search: {
          q: e.currentTarget.value
        }
      })
    }
  }

  const onSearch = () => {
    trackSearchButtonClick();
    router.get(`/vehicles`, {
      search: {
        q: inputRef.current?.value
      }
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        Rechercher un véhicule
      </div>
      <div className="relative">
        <Input
          type="text"
          ref={inputRef}
          onKeyDown={onKeyDown}
          placeholder="Marque, modèle..."
          className={styles.input}
        />
        <Search className={styles.searchIcon} onClick={onSearch} />
      </div>
      <div className={styles.popular}>
        <h2>
          Recherche populaire
        </h2>
        <div className="flex gap-2">
          {popularSearch.map((search) => (
            <button
              key={search}
              className={styles.tag}
              onClick={() => onPopularClear(search)}
            >
              {search.tag}
            </button>
          ))}
        </div>
        <div className="text-center">
          {isMobile && (
            <Button
              size="lg"
              variant="white"
              className="mt-4 w-full"
              onClick={() => router.visit('/vehicles')}
            >
                Voir tous les véhicules
            </Button>
        )}
        </div>
      </div>
    </div>
  )
}

export default HomeSearchBlock;